import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import Sidebar from './../components/sidebar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import axios from 'axios';

const Crearcursos = () => {
  const [curso, setCurso] = useState({
    nombrecurso: '',
    descripcion: '',
    materiales: '',
    ejercicios: '',
    categoria: '',
    portada: null
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurso(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validar tipo de archivo
      const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
      if (!validTypes.includes(file.type)) {
        setErrors(prev => ({
          ...prev,
          portada: 'Solo se permiten imágenes (JPEG, PNG, GIF)'
        }));
        return;
      }

      // Validar tamaño (max 2MB)
      if (file.size > 10 * 1024 * 1024) {
        setErrors(prev => ({
          ...prev,
          portada: 'La imagen no debe exceder 10MB'
        }));
        return;
      }

      setCurso(prev => ({
        ...prev,
        portada: file
      }));

      // Crear preview de la imagen
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);

      // Limpiar errores si todo está bien
      setErrors(prev => ({
        ...prev,
        portada: null
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!curso.nombrecurso.trim()) newErrors.nombrecurso = 'El nombre del curso es requerido';
    if (!curso.descripcion.trim()) newErrors.descripcion = 'La descripción es requerida';
    if (!curso.categoria) newErrors.categoria = 'La categoría es requerida';
    if (!curso.portada) newErrors.portada = 'La imagen de portada es requerida';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        // Crear FormData para enviar archivos
        const formData = new FormData();
        formData.append('nombrecurso', curso.nombrecurso);
        formData.append('descripcion', curso.descripcion);
        formData.append('materiales', curso.materiales);
        formData.append('ejercicios', curso.ejercicios);
        formData.append('categoria', curso.categoria);
        formData.append('portada', curso.portada);

        // Enviar datos al backend usando Axios
        const response = await axios.post(
          "https://api.mrcirp.com/public/crearcursos", 
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        if (response.data) {
          console.log('Curso creado:', response.data);
          setSuccess(true);
          // Limpiar el formulario después de enviar
          setCurso({
            nombrecurso: '',
            descripcion: '',
            materiales: '',
            ejercicios: '',
            categoria: '',
            portada: null
          });
          setPreviewImage(null);
          setTimeout(() => setSuccess(false), 3000);
        }
      } catch (error) {
        console.error('Error:', error);
        setErrors(prev => ({
          ...prev,
          submit: 'Error al crear el curso. Por favor, inténtalo de nuevo.'
        }));
      }
    }
  };

  return (
    <div>
      <Sidebar>
        <div className="container mt-4">
          <Row>
            <Col md={8} className="mx-auto">
              <Card>
                <Card.Header as="h5">Crear Nuevo Curso</Card.Header>
                <Card.Body>
                  {success && (
                    <Alert variant="success" onClose={() => setSuccess(false)} dismissible>
                      Curso creado exitosamente!
                    </Alert>
                  )}
                  
                  <Form onSubmit={handleSubmit} encType="multipart/form-data">
                    <Form.Group className="mb-3" controlId="nombrecurso">
                      <Form.Label>Nombre del Curso *</Form.Label>
                      <Form.Control
                        type="text"
                        name="nombrecurso"
                        value={curso.nombrecurso}
                        onChange={handleChange}
                        isInvalid={!!errors.nombrecurso}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.nombrecurso}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="descripcion">
                      <Form.Label>Descripción *</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="descripcion"
                        value={curso.descripcion}
                        onChange={handleChange}
                        isInvalid={!!errors.descripcion}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.descripcion}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="categoria">
                      <Form.Label>Categoría *</Form.Label>
                      <Form.Select
                        name="categoria"
                        value={curso.categoria}
                        onChange={handleChange}
                        isInvalid={!!errors.categoria}
                      >
                        <option value="">Selecciona una categoría</option>
                        <option value="academia">Academia</option>
                        <option value="mentoria">Mentoría</option>
                        <option value="certificacion">Certificación</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.categoria}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="portada">
                      <Form.Label>Imagen de Portada *</Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        isInvalid={!!errors.portada}
                      />
                      <Form.Text muted>
                        Formatos aceptados: JPEG, PNG, GIF. Tamaño máximo: 2MB
                      </Form.Text>
                      <Form.Control.Feedback type="invalid">
                        {errors.portada}
                      </Form.Control.Feedback>
                      
                      {previewImage && (
                        <div className="mt-3">
                          <Card.Img 
                            variant="top" 
                            src={previewImage} 
                            style={{ maxWidth: '200px', maxHeight: '200px' }} 
                            alt="Preview de portada"
                          />
                        </div>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="materiales">
                      <Form.Label>Materiales (URLs separadas por comas) *</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="materiales"
                        value={curso.materiales}
                        onChange={handleChange}
                        isInvalid={!!errors.materiales}
                        placeholder="Ej: https://ejemplo.com/material1.pdf, https://ejemplo.com/material2.zip"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.materiales}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="ejercicios">
                      <Form.Label>Ejercicios (Descripción o URLs) *</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="ejercicios"
                        value={curso.ejercicios}
                        onChange={handleChange}
                        isInvalid={!!errors.ejercicios}
                        placeholder="Ej: Resolver los problemas 1-5 del capítulo 3, https://ejemplo.com/ejercicios.pdf"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.ejercicios}
                      </Form.Control.Feedback>
                    </Form.Group>

                    {errors.submit && (
                      <Alert variant="danger" className="mt-3">
                        {errors.submit}
                      </Alert>
                    )}

                    <div className="d-grid gap-2">
                      <Button variant="primary" type="submit" size="lg">
                        Guardar Curso
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </Sidebar>
    </div>
  );
};

export default Crearcursos;